export enum NotificationsSuccessCodes {
  UPDATE_SUCCESSFUL = 'update_successful',
}
